import React, { useEffect, useMemo, useState } from "react";
import "../../styles/glass.css";
import "../../styles/globals.css";
import "../../styles/layout.css";
import "../styles/platform.css";
import "../styles/LeftSidebar.css";

import HeaderPlatform from "../components/HeaderPlatform";
import FooterPlatform from "../components/FooterPlatform";
import LeftSidebar from "../components/LeftSidebar";
import GlassCard from "../../components/GlassCard";
import NotificationBlock from "../components/NotificationBlock";

import { useCurrentLang } from "../../hooks/useCurrentLang";
import { exeNotiText } from "../data/platformText";
import {
  fetchNotifications,
  deleteNotification,
  markNotificationAsRead,
} from "../api/notificationsApi"; 

export const UserNotificationsPage = () => {
  const currentLang = useCurrentLang();
  const t = exeNotiText[currentLang];

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function loadNotifications() {
    try {
      setLoading(true);
      setError("");

      const data = await fetchNotifications();
      setNotifications(data);
    } catch (err) {
      setError(err.message || "Failed to load notifications");
    } finally {
      setLoading(false);
    }
  }

  async function handleDelete(id) {
    try {
      setError("");
      await deleteNotification(id);
      setNotifications((prev) => prev.filter((item) => item.id !== id));
    } catch (err) {
      setError(err.message || "Failed to delete notification");
    }
  }

  async function handleMarkAsRead(id) {
    try {
      const updated = await markNotificationAsRead(id);
      setNotifications((prev) =>
        prev.map((item) => (item.id === id ? updated : item))
      );
    } catch (err) {
      console.error("Failed to mark notification as read:", err);
    }
  }

  useEffect(() => {
    loadNotifications();
  }, []);

  const mappedNotifications = useMemo(() => {
    return notifications.map((notification) => ({
      id: notification.id,
      title: notification.title || "Notification",
      subject: notification.title || "Notification",
      date: notification.sent_at || notification.created_at,
      text: notification.message || "",
      is_read: notification.is_read,
    }));
  }, [notifications]);

  return (
    <div className="revimo-layout">
      <HeaderPlatform />

      <main className="revimo-main">
        <LeftSidebar />

        <div className="revimo-page-content">
          <GlassCard
            style={{
              padding: "10px",
              maxWidth: "775px",
              marginLeft: "50px",
            }}
          >
            <div className="profile-section header-section">
              <div className="profile-col profile-col-left">
                <div
                  className="profile-main-name"
                  style={{ paddingTop: "10px", width: "480px" }}
                >
                  {t.noti_title}
                </div>

                <div style={{ textAlign: "start" }}>
                  <div className="profile-main-username"></div>
                  <div className="profile-main-sex"></div>
                </div>
              </div>
            </div>
          </GlassCard>

          <GlassCard
            style={{
              padding: "10px",
              maxWidth: "775px",
              marginLeft: "50px",
              marginTop: "25px",
            }}
          >
            <div
              style={{
                fontSize: "0.8rem",
                textTransform: "uppercase",
                letterSpacing: "0.08em",
                opacity: 0.7,
              }}
            >
              {t.noti}
            </div>

            {loading && (
              <div style={{ marginTop: "16px", opacity: 0.8 }}>
                Loading notifications...
              </div>
            )}

            {error && (
              <div style={{ marginTop: "16px", color: "#ff6b6b" }}>
                {error}
              </div>
            )}

            {!loading && !error && mappedNotifications.length === 0 && (
              <div style={{ marginTop: "16px", opacity: 0.8 }}>
                No notifications found.
              </div>
            )}

            {!loading && !error && mappedNotifications.length > 0 && (
              <NotificationBlock
                notifications={mappedNotifications}
                onDelete={handleDelete}
                onNotificationClick={handleMarkAsRead}
                l_m="0px"
              />
            )}
          </GlassCard>
        </div>
      </main>

      <footer className="revimo-footer">
        <FooterPlatform />
      </footer>
    </div>
  );
};

export default UserNotificationsPage;